import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import StoriesPage from './pages/StoriesPage';
import StoryDetailPage from './pages/StoryDetailPage';
import MatchesPage from './pages/MatchesPage';
import MatchDetailPage from './pages/MatchDetailPage';
import ConfigPlayground from './pages/ConfigPlayground';
import AnalystPage from './pages/AnalystPage';
import ScenariosPage from './pages/ScenariosPage';
import ConversationPage from './pages/ConversationPage';
import MatchEventsPage from './pages/MatchEventsPage';
import ParityPage from './pages/ParityPage';

function NavLink({ to, children }: { to: string; children: React.ReactNode }) {
  const location = useLocation();
  const isActive = location.pathname === to ||
    (to !== '/' && location.pathname.startsWith(to));

  return (
    <Link
      to={to}
      className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
        isActive
          ? 'bg-pebbl-700 text-white'
          : 'text-pebbl-100 hover:bg-pebbl-500'
      }`}
    >
      {children}
    </Link>
  );
}

export default function App() {
  return (
    <div className="min-h-screen">
      {/* Navigation */}
      <nav className="bg-pebbl-600 shadow-lg">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="text-white font-bold text-xl">
                Pebbl Admin
              </Link>
              <div className="ml-10 flex items-center space-x-2">
                <NavLink to="/">Dashboard</NavLink>
                <NavLink to="/stories">Stories</NavLink>
                <NavLink to="/matches">Matches</NavLink>
                <NavLink to="/playground">Playground</NavLink>
                <NavLink to="/analyst">Analyst</NavLink>
                <NavLink to="/scenarios">Scenarios</NavLink>
                <NavLink to="/conversation">Conversation</NavLink>
                <NavLink to="/match-events">Match events</NavLink>
                <NavLink to="/parity">Parity</NavLink>
              </div>
            </div>
            <div className="text-pebbl-200 text-sm">
              v2.0 - Debug UI
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/stories/:id" element={<StoryDetailPage />} />
          <Route path="/matches" element={<MatchesPage />} />
          <Route path="/matches/:id" element={<MatchDetailPage />} />
          <Route path="/playground" element={<ConfigPlayground />} />
          <Route path="/analyst" element={<AnalystPage />} />
          <Route path="/scenarios" element={<ScenariosPage />} />
          {/* PD-2. The id is in the PATH so the screen is deep-linkable: every
              other PD package links into it by pebble id, and the bare path
              renders the id form so the nav entry has somewhere to go. */}
          <Route path="/conversation" element={<ConversationPage />} />
          <Route path="/conversation/:pebbleId" element={<ConversationPage />} />
          {/* PD-4. Same shape as the timeline: the pebble id in the PATH so a
              row, a session card or a story page can deep-link into the log,
              and the bare path renders the global tail. */}
          <Route path="/match-events" element={<MatchEventsPage />} />
          <Route path="/match-events/:pebbleId" element={<MatchEventsPage />} />
          {/* PD-5. Same shape again: the pebble id in the PATH, so the parity
              view is a link target and not only a nav entry. */}
          <Route path="/parity" element={<ParityPage />} />
          <Route path="/parity/:pebbleId" element={<ParityPage />} />
        </Routes>
      </main>
    </div>
  );
}
